import React, { Component } from 'react';
import './FillGap.scss';
import { QuestionContext } from '../../QuestionContext';

import FillGapQuestion from '../../QuestionsModal/FillGapQuestion';
import { SlideHeader } from 'src/pages/Course/Stages/Lessons/Cards/Components';

interface IProps {}
export default class FillGap extends Component<IProps> {
    static contextType = QuestionContext;
    context!: React.ContextType<typeof QuestionContext>;
    render() {
        const { questions, heading, subHeading, content, userAnswers } = this.context;

        return (
            <>
                <SlideHeader heading={heading} subHeading={subHeading} />
                <div className='fillgap-container'>
                    {content && <div className='fillgap-content' dangerouslySetInnerHTML={{ __html: content }} />}
                    <div className='fillgap-questions'>
                        {questions.map(({ question, options }: any, index: number) => (
                            <FillGapQuestion
                                key={'fill-' + index}
                                title={question}
                                options={options.map((option: any) => option.text)}
                                answer={userAnswers?.[index]?.[0] ?? -1}
                                onAnswer={(res) => this.context.selectAnswer(index, null, res)}
                                prepend={<b key='prefix'>{index + 1}.</b>}
                            />
                        ))}
                    </div>
                </div>
            </>
        );
    }
}
